var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokBw = function SvgTiktokBw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.65 7.82a3.1 3.1 0 0 1-1.41-2.61H12v8.97c-.04 1-.87 1.81-1.88 1.81-.31 0-.61-.08-.87-.22-.6-.32-1.01-.94-1.01-1.66 0-1.04.84-1.88 1.88-1.88.19 0 .38.03.55.09v-2.28c-.18-.02-.37-.04-.55-.04C7.85 10 6 11.85 6 14.12c0 1.39.7 2.63 1.76 3.37.67.47 1.48.75 2.36.75 2.27 0 4.12-1.85 4.12-4.12V9.57c.88.63 1.95 1 3.11 1V8.33c-.62 0-1.21-.19-1.69-.5Z"
  })));
};
export default SvgTiktokBw;